import React from "react";

const Atmosphere = () => (
  <div className="atmosphere" aria-hidden="true">
    <div className="atmosphere__grid" />
    <div className="atmosphere__vignette" />
  </div>
);

export default Atmosphere;
